"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var collapse_1 = require("./collapse");
var collapse_2 = require("./collapse");
exports.NgbCollapse = collapse_2.NgbCollapse;
var NgbCollapseModule = (function () {
    function NgbCollapseModule() {
    }
    NgbCollapseModule_1 = NgbCollapseModule;
    NgbCollapseModule.forRoot = function () { return { ngModule: NgbCollapseModule_1, providers: [] }; };
    NgbCollapseModule = NgbCollapseModule_1 = __decorate([
        core_1.NgModule({ declarations: [collapse_1.NgbCollapse], exports: [collapse_1.NgbCollapse] })
    ], NgbCollapseModule);
    return NgbCollapseModule;
    var NgbCollapseModule_1;
}());
exports.NgbCollapseModule = NgbCollapseModule;
//# sourceMappingURL=collapse.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/collapse/collapse.module.js
// module id = 37
// module chunks = 0